import { Linker } from "./Linker.js";
export async function loadLinksInteraction(engine, refresh = true) {
    await engine.addInteractor("particlesLinks", (container) => new Linker(container), refresh);
}
